export enum SourceStatus {
  SUBMITTED = "SUBMITTED",
  PROCESSING = "PROCESSING",
  FAILED = "FAILED",
  COMPLETED = "COMPLETED",
} 